import scssVariables from '@styles/base/variable-export.scss'
const DEFAULT_TOAST_ZINDEX = scssVariables.TOAST_Z_INDEX
const TOAST_VISIBLE_CLASS = 'visible'
const TOAST_TRANSITION_OUT_CLASS = 'transition-out'
let currentZIndex = DEFAULT_TOAST_ZINDEX

function getZIndex() {
  return currentZIndex++
}

function Toast(arg) {
  if (!arg) {
    throw new Error('TOAST_WITHOUT_ARGS')
  }
  let content
  let timeout = 3000
  const classname = ['ph-toast']
  let contentEle = null
  const clickCallback = arg.onClick || function() {
    // noop
  }
  const zIndex = getZIndex()
  const n = document.createElement('div')
  if (typeof arg.timeout === 'number' && arg.timeout >= 0) {
    timeout = arg.timeout
  }
  if (arg.classname) {
    classname.push(arg.classname)
  }
  if (arg.content) {
    content = arg.content
  } else {
    content = arg
  }
  if (arg.contentEle) {
    contentEle = arg.contentEle
    content = ''
  }
  n.innerHTML = `<div class="${classname.join(' ')}" style="z-index:${zIndex}"><span class="ph-toast__icon ${arg.type || 'success'}"></span>${content}</div>`

  this.$node = n.firstChild
  if (contentEle) {
    this.$node.appendChild(contentEle)
  }
  this.$node.addEventListener('click', clickCallback)
  this.timeout = timeout
  if (this.timeout) {
    this.timer = window.setTimeout(() => {
      this.close()
    }, this.timeout)
  }
  document.body.appendChild(this.$node)
  window.setTimeout(() => {
    this.show()
  })
}

Toast.prototype.show = function () {
  this.$node.classList.add(TOAST_VISIBLE_CLASS)
}

Toast.prototype.moveUpAndClose = function () {
  this.$node.addEventListener('transitionend', () => {
    this.close()
  })
  this.$node.classList.add(TOAST_TRANSITION_OUT_CLASS)
}

Toast.prototype.close = function () {
  this.$node.addEventListener('transitionend', () => {
    this.destroy()
  })
  this.$node.classList.remove(TOAST_VISIBLE_CLASS)
}

Toast.prototype.destroy = function () {
  window.clearTimeout(this.timer)
  if (window.document.body.contains(this.$node)) {
    window.document.body.removeChild(this.$node)
  }
}

export default Toast
